module.exports = __webpack_public_path__ + "static/media/iconCoin.ece74785.svg";